import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import COOWorkspace from './COOWorkspace.jsx';
import { COO_LOGIN_PATH, hasCOOSession } from './cooAuth.js';

export default function COOProtectedRoute() {
  const session = useSelector(state => state.universeStaffs);
  const location = useLocation();
  if (!hasCOOSession(session)) {
    return <Navigate to={COO_LOGIN_PATH} state={{ from: location }} replace />;
  }
  return <COOWorkspace />;
}
